import { type IOwnershipFilter } from 'src/containers/Home/model';

export const APPS_PER_PAGE = 20;

export const EMPTY_MESSAGE_BY_FILTER: Record<IOwnershipFilter, string> = {
  all: 'No applications yet',
  yours: "You don't have any applications yet",
  vendors: 'No vendor applications yet',
};
